import { useAppSelector } from '../../global/hooks';
import { Modal, ModalBody, ModalCloseButton, ModalHead, PrimaryButton } from '../../global/styles';
import useHasNoSections from '../../hooks/useHasNoSections';
import { useGetUserQuery } from '../../store/apiSlice';
import { selectView, setView } from '../../store/appSlice';
import { clearAll } from '../../store/sectionsSlice';
import DeleteButton from '../Buttons/DeleteButton';
import ProButton from '../Buttons/ProButton';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useClickAway } from 'react-use';

const proLink = 'https://chordplayer.app/features';

export default function EditApp() {
	const dispatch = useDispatch();
	const hasSections = !useHasNoSections();
	const isVisible = useAppSelector(selectView) === 'editApp';

	const { data: user } = useGetUserQuery();
	const isPro = Boolean(user?.pro);

	const closeModal = () => {
		dispatch(setView('main'));
	};
	const handleDeleteAll = () => {
		dispatch(clearAll());
		closeModal();
	};
	const ref = useRef(null);
	useClickAway(ref, () => {
		closeModal();
	});

	return isVisible ? (
		<Modal ref={ref}>
			<ModalCloseButton
				onClick={closeModal}
				title="close this modal popup"
				aria-label="close this modal poup"
			/>
			<div>
				<ModalHead>Options</ModalHead>
				<ModalBody>
					{hasSections && (
						<DeleteButton
							confirmMessage="Are you sure you want to delete all sections and chords?"
							onClick={handleDeleteAll}
							title="Delete all sections and chords"
							aria-label="Delete all sections and chords"
						>
							Clear all chords
						</DeleteButton>
					)}
					<ProButton>
						<a href={proLink}>Load</a>
					</ProButton>
					<ProButton>
						<a href={proLink}>Save</a>
					</ProButton>
					<ProButton>
						<a href={proLink}>Chord Options</a>
					</ProButton>
					<ProButton>
						<a href={proLink}>Drums</a>
					</ProButton>
					<ProButton>
						<a href={proLink}>Click</a>
					</ProButton>
					{!isPro && (
						<PrimaryButton>
							<a href={proLink}>View Pro features</a>
						</PrimaryButton>
					)}
				</ModalBody>
			</div>
		</Modal>
	) : null;
}
